import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState, Profile, UserSettings, FilialeProfile } from "@models/user.model";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState: UserState = {
  id: "",
  role: "",
  lastLogin: "",
  settings: {
    lang: "de",
    theme: "light",
    sidebar: "close",
    lastPath: "/",
    contacts: null,
    rememberMe: false,
    updated_at: new Date().toISOString(),
  },
  profile: {
    customer_id: "",
    customer_number: "",
    points: 0,
    salutation: "",
    title: "",
    lastname: "",
    firstname: "",
    phone: "",
    street: "",
    zip: "",
    city: "",
    country: "",
    email: "",
    birthday: "",
    gender: "",
    created_at: "",
    revenue_count: 0,
    customer_card_number: 0,
    einwilligungen: null,
    promotions: [],
    fe_umsaetze: null,
  },
  filialeProfile: null,
  status: "idle",
  error: null,
};

const userPersistConfig = {
  key: "user",
  storage,
  whitelist: ["settings", "profile", "filialeProfile"],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
  
    setUser: (state, action: PayloadAction<Partial<UserState>>) => {
      return { ...state, ...action.payload };
    },
    updateProfile: (state, action: PayloadAction<Partial<Profile>>) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    updateFilialeProfile: (state, action: PayloadAction<Partial<FilialeProfile>>) => {
      state.filialeProfile = state.filialeProfile ? { ...state.filialeProfile, ...action.payload } : action.payload as FilialeProfile;
    },
    clearFilialeProfile: (state) => {
      state.filialeProfile = null;
    },
    updateSettings: (state, action: PayloadAction<Partial<UserSettings>>) => {
      state.settings = {
        ...state.settings,
        ...action.payload,
        updated_at: new Date().toISOString(),
      };
    },
    updateRememberMe: (state, action: PayloadAction<boolean>) => {
      state.settings.rememberMe = action.payload;
      state.settings.updated_at = new Date().toISOString();
    },
    updateLastLogin: (state) => {
      state.lastLogin = new Date().toISOString();
    },
    updateLastPath: (state, action: PayloadAction<string>) => {
      state.settings.lastPath = action.payload;
      state.settings.updated_at = new Date().toISOString();
    },
    toggleSidebar: (state) => {
      state.settings.sidebar =
        state.settings.sidebar === "open" ? "close" : "open";
      state.settings.updated_at = new Date().toISOString();
    },
    openSidebar: (state) => {
      state.settings.sidebar = "open";
      state.settings.updated_at = new Date().toISOString();
    },
    closeSidebar: (state) => {
      state.settings.sidebar = "close";
      state.settings.updated_at = new Date().toISOString();
    },
  
    setUserLoading: (state) => {
      state.status = "loading";
    },
    setUserSuccess: (state) => {
      state.status = "succeeded";
    },
    setUserError: (state, action: PayloadAction<string>) => {
      state.status = "failed";
      state.error = action.payload;
    },
  },

});

export const {
  setUser,
  updateProfile,
  updateFilialeProfile,
  clearFilialeProfile,
  updateSettings,
  updateRememberMe,
  updateLastLogin,
  updateLastPath,
  toggleSidebar,
  openSidebar,
  closeSidebar,
  setUserLoading,
  setUserSuccess,
  setUserError,
} = userSlice.actions;

export default persistReducer(userPersistConfig, userSlice.reducer);